import React from 'react';
import Layout from '../components/Layout/Layout';

// Import event images
import annualDayImg from '../images/annual-day.jpg';
import culturalImg from '../images/cultural festival1.jpeg';
import sportsDayImg from '../images/sports-day.jpeg';
import scienceExImg from '../images/science-exhibition.jpeg';
import graduationImg from '../images/graduation-ceremony.jpeg';
import freshersImg from '../images/student-club.jpeg';
import seminarImg from '../images/seminar-lecture.jpeg';
import republicDayImg from '../images/republic-day.jpeg';

const CollegeEventsPage = () => {
  const events = [
    { title: 'Annual Day Celebration', image: annualDayImg },
    { title: 'Cultural Festival Performance', image: culturalImg },
    { title: 'Sports Day Award Ceremony', image: sportsDayImg },
    { title: 'Science Exhibition Project', image: scienceExImg },
    { title: 'Graduation Ceremony', image: graduationImg },
    { title: 'Freshers Party Fun', image: freshersImg },
    { title: 'Academic Seminar Lecture', image: seminarImg },
    { title: 'Republic Day Parade', image: republicDayImg },
  ];

  return (
    <Layout>
      <div id="college-events" className="page-container" style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 20px', minHeight: '500px' }}>
        
        <h2 style={{ color: '#004d99', borderBottom: '1px solid #90cdf4', paddingBottom: '20px', marginBottom: '30px', textAlign: 'center', fontSize: '2.8rem', fontWeight: 'bold' }}>
          College Events Gallery
        </h2>

        <p style={{ color: '#444', textAlign: 'center', maxWidth: '800px', margin: '0 auto 40px', lineHeight: '1.6', fontSize: '1.1rem' }}>
          A pictorial journey through the vibrant and memorable events that take place at Late Sanjay Tompe and Late Sameer Deshmukh B.Ed College throughout the academic year. These moments define our campus spirit and community.
        </p>

        <div style={{ 
          backgroundColor: '#fff', 
          border: '1px solid #e2e8f0', 
          borderLeft: '5px solid #3182ce', 
          padding: '30px', 
          borderRadius: '8px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '25px'
          }}>
            {events.map((event, index) => (
              <div key={index} style={{
                backgroundColor: '#fff',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column'
              }}>
                <div style={{ height: '250px', overflow: 'hidden' }}>
                  <img 
                    src={event.image} 
                    alt={event.title} 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                  />
                </div>
                <div style={{ 
                  backgroundColor: '#f1f5f9', 
                  padding: '15px', 
                  textAlign: 'center', 
                  fontSize: '1rem', 
                  fontWeight: '600', 
                  color: '#334155' 
                }}>
                  {event.title}
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </Layout>
  );
};

export default CollegeEventsPage;
